import { Building2, ShieldAlert, Edit2, Trash2, Network, Check } from "lucide-react";
import { StatusBadge } from "../../index.jsx";

export default function UserDetail({ user, onBack }) {
  
  return (
    <div className="animate-in fade-in slide-in-from-bottom-4 duration-500 space-y-6">
      {/* Profile Header */}
      <div className="bg-white dark:bg-slate-800 rounded-[2rem] shadow-sm border border-slate-100 dark:border-slate-700 p-8 flex flex-col sm:flex-row items-start sm:items-center gap-6">
        <div className="w-24 h-24 rounded-full bg-slate-100 dark:bg-slate-700 flex items-center justify-center text-4xl font-bold text-[#1d57a5] dark:text-[#4a8ce3] shadow-inner">
          {user.firstName.charAt(0)}
        </div>
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-2">
            <h2 className="text-3xl font-bold text-slate-800 dark:text-white">
              {user.firstName} {user.middleName} {user.lastName}
            </h2>
            <StatusBadge status="active" />
          </div>
          <div className="flex flex-col sm:flex-row sm:items-center gap-4 text-sm text-slate-500">
            {/* <span className="flex items-center gap-1.5">
              <Building2 size={16} className="text-[#1d57a5]" /> {user.company}
            </span>
            <span className="hidden sm:inline text-slate-300 dark:text-slate-600">
              •
            </span> */}
            <span className="flex items-center gap-1.5">
              <ShieldAlert size={16} className="text-purple-500" /> {user.role}
            </span>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Contact Information */}
        <div className="col-12">
          <div className="bg-white dark:bg-slate-800 rounded-[2rem] shadow-sm border border-slate-100 dark:border-slate-700 p-8">
            <h3 className="text-sm font-bold text-slate-800 dark:text-slate-200 mb-6 flex items-center gap-2 border-b border-slate-100 dark:border-slate-700 pb-3">
              <Network size={18} className="text-[#1d57a5] dark:text-[#4a8ce3]" />{" "}
              Contact Information
            </h3>
            <div className="space-y-5">
              <div>
                <p className="text-xs font-semibold text-slate-500 mb-1">
                  Email Address
                </p>
                <p className="text-sm font-medium text-slate-800 dark:text-white border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 min-h-[2.5rem] bg-slate-50 dark:bg-slate-900/40">
                  {user.email}
                </p>
              </div>
              <div>
                <p className="text-xs font-semibold text-slate-500 mb-1">
                  Phone Number
                </p>
                <p className="text-sm font-medium text-slate-800 dark:text-white border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 min-h-[2.5rem] bg-slate-50 dark:bg-slate-900/40">
                  {user.mobileNo}
                </p>
              </div>
              <div>
                <p className="text-xs font-semibold text-slate-500 mb-1">
                  Address 1
                </p>
                <p className="text-sm font-medium text-slate-800 dark:text-white border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 min-h-[2.5rem] bg-slate-50 dark:bg-slate-900/40">
                  {user.address1}
                </p>
              </div>
              <div>
                <p className="text-xs font-semibold text-slate-500 mb-1">
                  Address 2
                </p>
                <p className="text-sm font-medium text-slate-800 dark:text-white border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 min-h-[2.5rem] bg-slate-50 dark:bg-slate-900/40">
                  {user.address2}
                </p>
              </div>
              <div>
                <p className="text-xs font-semibold text-slate-500 mb-1">
                  Address 3
                </p>
                <p className="text-sm font-medium text-slate-800 dark:text-white border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 min-h-[2.5rem] bg-slate-50 dark:bg-slate-900/40">
                  {user.address3}
                </p>
              </div>
              <div>
                <p className="text-xs font-semibold text-slate-500 mb-1">
                  Pin Code
                </p>
                <p className="text-sm font-medium text-slate-800 dark:text-white border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 min-h-[2.5rem] bg-slate-50 dark:bg-slate-900/40">
                  {user.pincode}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* Company Information */}
        <div className="col-12">
          <div className="bg-white dark:bg-slate-800 rounded-[2rem] shadow-sm border border-slate-100 dark:border-slate-700 p-8">
            <h3 className="text-sm font-bold text-slate-800 dark:text-slate-200 mb-6 flex items-center gap-2 border-b border-slate-100 dark:border-slate-700 pb-3">
              <Network size={18} className="text-[#1d57a5] dark:text-[#4a8ce3]" />{" "}
              Company Information
            </h3>
            <div className="space-y-5">
              <div>
                <p className="text-xs font-semibold text-slate-500 mb-1">
                  Company Name
                </p>
                <p className="text-sm font-medium text-slate-800 dark:text-white border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 min-h-[2.5rem] bg-slate-50 dark:bg-slate-900/40">
                  {user.companyName}
                </p>
              </div>
              <div>
                <p className="text-xs font-semibold text-slate-500 mb-1">
                  Company Email
                </p>
                <p className="text-sm font-medium text-slate-800 dark:text-white border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 min-h-[2.5rem] bg-slate-50 dark:bg-slate-900/40">
                  {user.companyEmail}
                </p>
              </div>
              <div>
                <p className="text-xs font-semibold text-slate-500 mb-1">
                  Address 1
                </p>
                <p className="text-sm font-medium text-slate-800 dark:text-white border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 min-h-[2.5rem] bg-slate-50 dark:bg-slate-900/40">
                  {user.address1}
                </p>
              </div>
              <div>
                <p className="text-xs font-semibold text-slate-500 mb-1">
                  Address 2
                </p>
                <p className="text-sm font-medium text-slate-800 dark:text-white border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 min-h-[2.5rem] bg-slate-50 dark:bg-slate-900/40">
                  {user.address2}
                </p>
              </div>
              <div>
                <p className="text-xs font-semibold text-slate-500 mb-1">
                  Address 3
                </p>
                <p className="text-sm font-medium text-slate-800 dark:text-white border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 min-h-[2.5rem] bg-slate-50 dark:bg-slate-900/40">
                  {user.address3}
                </p>
              </div>
              <div>
                <p className="text-xs font-semibold text-slate-500 mb-1">
                  Pin Code
                </p>
                <p className="text-sm font-medium text-slate-800 dark:text-white border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 min-h-[2.5rem] bg-slate-50 dark:bg-slate-900/40">
                  {user.pincode}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
